import { motion } from 'framer-motion'
import { useEffect } from 'react'
import './FortuneLoadingScreen.css'
import preloaderBg from '../../assets/images/fortuneLoader/Прелоадер.svg'
import logo from '../../assets/images/logoLoad.svg'

interface FortuneLoadingScreenProps {
  isLoading: boolean
  onComplete?: () => void
}

const FortuneLoadingScreen = ({
  isLoading,
  onComplete,
}: FortuneLoadingScreenProps) => {
  useEffect(() => {
    if (isLoading) {
      document.body.style.overflow = 'hidden'
      document.documentElement.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
      document.documentElement.style.overflow = ''
    }

    return () => {
      document.body.style.overflow = ''
      document.documentElement.style.overflow = ''
    }
  }, [isLoading])

  useEffect(() => {
    if (isLoading && onComplete) {
      const timer = setTimeout(() => {
        onComplete()
      }, 3500)

      return () => clearTimeout(timer)
    }
  }, [isLoading, onComplete])

  if (!isLoading) return null

  return (
    <motion.div
      className="fortune-loading-screen"
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      style={{ backgroundImage: `url(${preloaderBg})` }}
    >
      <div className="fortune-loading-content">
        <img src={logo} alt="logo" className="fortune-loading-logo" />

        <div className="fortune-loading-progress-wrap">
          <div className="fortune-loading-progress">
            <motion.div
              className="fortune-loading-progress__fill"
              initial={{ width: '0%' }}
              animate={{ width: '100%' }}
              transition={{
                delay: 0.2,
                duration: 3,
                ease: [0.25, 0.1, 0.25, 1],
              }}
            />
          </div>
          <p className="fortune-loading-caption">загружаем..</p>
        </div>
      </div>
    </motion.div>
  )
}

export default FortuneLoadingScreen
